import { connect } from 'react-redux'
import ResourceLinkList from './component'

import NavigationHelper from 'layers/navigation/navigationHelper'

export default connect(
  null,
  NavigationHelper.mapDispatchToProps,
)(ResourceLinkList)
